import React, { Fragment, FunctionComponent } from "react";

interface IProps {
    notification: Spintr.IAcademySessionNotification;
}

export const AcademySessionNotification: FunctionComponent<IProps> = ({ notification }) => {
    if (!notification) {
        return null;
    }

    return (
        <Fragment>
            <span className="academy-session-notification-heading">{notification.heading}</span>
            {notification.body ? " " + notification.body : ""}
        </Fragment>
    );
};

export default AcademySessionNotification;
